import React from 'react';

import { CommandMenu } from '@/components/CommandMenu';
import { ModeToggle } from '@/components/mode-toggle';
import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import {
  BreadcrumbType,
  ConnectedBreadcrumbs,
} from '@/components/ConnectedBreadcrumbs';

export const ManagerHeader: React.FC<{
  noSidebar?: boolean;
  breadCrumbs?: BreadcrumbType[];
}> = (props) => {
  return (
    <header className="flex h-16 shrink-0 items-center gap-2 pr-4 shadow-sm rounded-[inherit] rounded-b-none sticky bg-background top-0 z-10 dark:border-b">
      <div className="flex items-center gap-2 px-4">
        {!props.noSidebar && <SidebarTrigger className="-ml-1" />}
        {!props.noSidebar && (
          <Separator orientation="vertical" className="mr-2 h-4" />
        )}
        <ConnectedBreadcrumbs breadcrumbs={props.breadCrumbs} />
      </div>
      <div className="flex flex-1 min-w-0 items-center justify-between gap-2 md:justify-end">
        <div className="w-full flex-1 md:w-auto md:flex-none">
          <CommandMenu />
        </div>
        <nav className="flex items-center gap-0.5">
          <ModeToggle />
        </nav>
      </div>
    </header>
  );
};
